import { CopyAll } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { enumSnackbarStatusType } from "../../../../types/enums";
import { showSnackbar } from "../../../../stores/redux/actions";
import { useDispatch } from "react-redux";

type CopyToClipboardButtonProps = {
    text: string;
}

const CopyToClipboardButton = ({...props} : CopyToClipboardButtonProps) => {
    const dispatch = useDispatch();
  
    const handleClick = () => {
      navigator.clipboard.writeText(props.text);

      dispatch(showSnackbar({ 
        message: "Copied to clipboard!", 
        status: enumSnackbarStatusType.success
      }))
    };
  
    return (
      <>
        <IconButton onClick={handleClick}>
            <CopyAll style={{ height: 24, width : 24}} />
        </IconButton>
      </>
    );
  };
  
  export default CopyToClipboardButton;